import {h} from 'preact';
import s from "./categoriesFormTree.module.css";
import {useCategoriesFormTree} from "./useCategoriesFormTree";
import GroupCategory from "./GroupCategory";

/**
 * The actual component where the iterated categories will be rendered in.
 *
 * This is necessary, so we can switch between the mobile and desktop states without having to
 * perform a full page refresh, like it's being currently done in the Magento 1 store version.
 *
 * It's also important to notice that it requires a few props to work correctly,
 * those being `data`, `shouldDisplayClearButton` and `handleClear`.
 * */
const CategoriesFormTree = props => {
    // Destructured component props
    const {
        data,
        shouldDisplayClearButton,
        handleChange,
        handleClear,
        selectedCategories,
        shouldFilter,
        collapseController,
        handleCollapseController
    } = props;

    // Component logic data
    const componentProps = useCategoriesFormTree({
        rawData: data,
        selectedCategories,
        shouldFilter,
        collapseController,
        handleCollapseController
    });

    // Destructured component logic data
    const {
        additionalCategories,
        handleCollapse
    } = componentProps;

    return (data && collapseController.length > 0) ? (
        <form className={"w-full categories-filter-tree"} data-testid="categories-form-tree">
            <div className={"flex flex-col gap-2"}>
                {/* Root block iterator */}
                {collapseController && data.map((parentCategory, index) => {
                    return (
                        <GroupCategory
                            key={parentCategory.id}
                            parentCategory={parentCategory}
                            index={index}
                            handleChange={handleChange}
                            handleCollapse={handleCollapse}
                            collapseController={collapseController}
                            selectedCategories={selectedCategories}
                            additionalCategories={additionalCategories}
                        />
                    )
                })}
            </div>
            <button
                type={"button"}
                id={"categories-clear-button"}
                className={s.clearButton + (shouldDisplayClearButton ? "" : " hidden")}
                onClick={() => handleClear()}
                data-testid="category-form-handle-clear"
            >
                Limpar filtros
            </button>
        </form>
    ) : null;
}

export default CategoriesFormTree;
